<template>
    <v-content>
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>Login form</v-toolbar-title>
                            <v-spacer />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        href="https://api.weibo.com/oauth2/authorize?client_id=YOUR_CLIENT_ID&response_type=code&redirect_uri=YOUR_REGISTERED_REDIRECT_URI"
                                        icon
                                        large
                                        target="_blank"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-sina-weibo</v-icon>
                                    </v-btn>
                                </template>
                                <span>Weibo</span>
                            </v-tooltip>
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon large href="https://codepen.io/johnjleider/pen/pMvGQO" target="_blank" v-on="on">
                                        <v-icon>mdi-codepen</v-icon>
                                    </v-btn>
                                </template>
                                <span>Codepen</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <v-text-field v-model="username" label="Login" name="login" prepend-icon="mdi-account" type="text" />
                                <v-text-field v-model="password" label="Password" name="password" prepend-icon="mdi-lock" type="password" />
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="primary" @click="login">Login</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
import { Log } from "../utils/debug";
import { apiLogin, apiGetRecaptchaID } from "../api/login";
import { mapMutations } from "vuex";
import { load as recaptchaLoad } from "recaptcha-v3";

export default {
    name: "Login",
    data: () => ({
        username: "",
        password: ""
    }),
    methods: {
        ...mapMutations(["muSetToken"]),
        login() {
            let that = this;
            apiGetRecaptchaID().then(res => {
                /* 1st, get the google ID */
                let recaptchaID = res.data;
                Log.debug(recaptchaID);
                recaptchaLoad(recaptchaID, {
                    useRecaptchaNet: true,
                    autoHideBadge: true
                }).then(recaptcha => {
                    /* 2nd, use ID exchange the google token */
                    recaptcha.execute("login").then(token => {
                        /* 3rd, send the token, and other formData to backend, check it */
                        Log.debug(token);
                        apiLogin({
                            RecaptchaToken: token,
                            Username: this.username,
                            Password: this.password
                        }).then(res => {
                            Log.debug(res);
                            that.muSetToken(res.data);
                            this.$router.push("/admin/board");
                        });
                    });
                });
            });
        }
    }
};
</script>

<style scoped></style>
